import { render, staticRenderFns } from "./HistoricalResultsCard.vue?vue&type=template&id=36d7e2d9&scoped=true"
import script from "./HistoricalResultsCard.vue?vue&type=script&lang=js"
export * from "./HistoricalResultsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d7e2d9",
  null
  
)

export default component.exports